import BasicSetting from "./config";
import axios from 'axios'
import store from '@/store'


var basicSetting = BasicSetting.BasicSetting.create();
const service = axios.create({
	baseURL: basicSetting.getApiUrl(),
	timeout: 50000 // request timeout
})
service.interceptors.request.use(
	config => {
		var Authorization = localStorage.getItem("token");
		// 在发送请求之前做些什么
		config.headers['Authorization'] = Authorization?'Bearer '+ Authorization:''
		return config
	},
	error => {
		// 处理请求错误
		console.log(error) // for debug
		return Promise.reject(error)
	}
)
service.interceptors.response.use(
	/**
	 * 如果您想获取http信息，如头或状态
	 * Please return  response => response
	 */
	/**
	 * 通过自定义代码确定请求状态
	 * 您还可以通过HTTP状态代码来判断状态
	 */
	response => {
	  // 顶部铃铛小红点处理
    if (response.headers && response.headers['is-red-dot'] !== undefined) {
      // is-red-dot 等于 1 就显示小红点
      store.commit('setTopBellRedDotShow', response.headers['is-red-dot'] === '1');
    }

		const res = response.data
		if(res.code == 401){
			//清除cookie
			localStorage.clear()
			window.location.href = '/login'
		}
		return res;
	},
	error => {
		return Promise.reject(error)
	}
)

export default service
